export class ExhaustiveError extends Error {
  value: never;

  constructor(value: never) {
    super(`Exhaustive error: ${value}`);
    this.value = value;
  }
}
